import { Rule } from "antd/lib/form"

import i18n from "Shared/locales/i18n"

export const createSubstituteRules = () => ({
    primary_substitute: [{ required: true, message: i18n.t("validation:required") }] as Array<Rule>,
})
